import controller from './settings-context-panel-controller';

const SettingsContextPanelComponent: angular.IComponentOptions = {
  controller,
  controllerAs: 'ctrl',
  bindings: {
    title: '@',
    subtitle: '@',
    context: '<',
    listType: '<',
    enabled: '=?',
    filterEnabled: '=?',
    panelHeight: '<',
    listAvailable: '<',
    listSelected: '<',
    onDismiss: '&?',
    onUpdate: '&',
  },
  template: `
    <div class="settings-context-panel" ng-class="{'is-disabled': !ctrl.enabled}" style="height: {{ctrl.getPanelHeight()}}px">

      <div class="settings-panel-header">
        <span class="header-title">
          {{ctrl.title}} - {{ctrl.subtitle}}
        </span>
        <a class="dismiss-trigger" href="#" ng-click="ctrl.dismiss($event)">
          <i class="icon-dismiss-white-blue"></i>
        </a>
      </div>

      <!-- Settings Panel Body Begins -->
      <div class="settings-panel-body">

        <!-- Settings Panel Controls Begin -->
        <div class="settings-panel-controls" ng-if="ctrl.filterEnabled">
          <input type="text"
                 ng-if="ctrl.filterEnabled"
                 class="form-control form-control-sm form-control-block"
                 ng-model="ctrl.filterPattern"
                 ng-model-options="ctrl.filterOptions"
                 placeholder="Find..." />
        </div>
        <!-- @Settings Panel Controls End -->

        <!-- Settings Panel Container Begins -->
        <div class="settings-panel-container">

          <!-- Select All Begins -->
          <span ng-if="ctrl.isListTypeMultiple()" class="checkbox-icon option-field">
            <input
              id="select-all-{{$id}}"
              name="select-all"
              type="checkbox"
              ng-class="{'partially-selected': ctrl.isPartiallySelected()}"
              ng-checked="ctrl.isAllSelected()"
              ng-click="ctrl.handleSelectAllClick($event)"
              />
            <label class="option-label inline-icon icon-editor-checkbox-light-unchecked"
                   for="select-all-{{$id}}">
              (Select All)
            </label>
          </span>
          <!-- @Select All End -->

          <!-- List Item Begins -->
          <span ng-repeat="item in ctrl.listAvailable | filter:ctrl.filterPattern">

            <!-- Multiple Selection Item Iterator Begins -->
            <span ng-if="ctrl.isListTypeMultiple()" class="checkbox-icon option-field">
              <input
                id="field-{{ctrl.itemValue(item)}}-{{$id}}"
                name="selectedItems[]"
                type="checkbox"
                value="{{ctrl.itemValue(item)}}"
                ng-checked="ctrl.isSelected(ctrl.itemValue(item))"
                ng-click="ctrl.toggleSelection(ctrl.itemValue(item))"
                />
              <label class="option-label inline-icon icon-editor-checkbox-light-unchecked"
                     for="field-{{ctrl.itemValue(item)}}-{{$id}}">
                {{ctrl.itemDisplayName(item)}}
              </label>
            </span>
            <!-- @Multiple Selection Item Iterator Ends -->

            <!-- Simple Selection Item Iterator Begins -->
            <span ng-if="ctrl.isListType(ctrl.CONTEXT_LIST_TYPE_SINGLE)" class="radio-icon option-field">
              <input
                id="field-{{ctrl.itemValue(item)}}-{{$id}}"
                group="radio-field-{{$id}}"
                name="selectedItems[]"
                type="radio"
                value="{{ctrl.itemValue(item)}}"
                ng-checked="ctrl.isSelected(ctrl.itemValue(item))"
                ng-click="ctrl.setSelection(ctrl.itemValue(item))"
                />
              <label class="option-label inline-icon icon-radio-inactive"
                     for="field-{{ctrl.itemValue(item)}}-{{$id}}">
                {{ctrl.itemDisplayName(item)}}
              </label>
            </span>
            <!-- @Simple Selection Item Iterator Ends -->

          </span>
          <!-- @List Item Ends -->

        </div>
        <!-- @Settings Panel Container Ends -->

      </div>
      <!-- Settings Panel Body Begins -->

    </div>
  `,
};

export { SettingsContextPanelComponent };
